import { APP_INITIALIZER, NgModule } from '@angular/core';

import {
  AuthModule,
  OidcConfigService,
  LogLevel,
} from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

export function configureAuth(
  oidcConfigService: OidcConfigService
): () => Promise<void> {
  return () =>
    oidcConfigService.withConfig({
      stsServer: environment.oidc.authority,
      redirectUrl: `${window.location.origin}/unauthorized`,
      postLogoutRedirectUri: environment.oidc.resource,
      clientId: environment.oidc.clientId,
      scope: environment.oidc.scope,
      responseType: environment.oidc.responseType,
      silentRenew: true,
      customParams: {
        prompt: 'select_account',
        resource: environment.oidc.resource,
        channel: environment.oidc.channel,
      },
      silentRenewUrl: `${window.location.origin}/silent-renew.html`,
      useRefreshToken: false,
      renewTimeBeforeTokenExpiresInSeconds: 60,
      logLevel: LogLevel.Error,
      autoUserinfo: false,
    });
}

@NgModule({
  imports: [AuthModule.forRoot()],
  exports: [AuthModule],
  providers: [
    OidcConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureAuth,
      deps: [OidcConfigService],
      multi: true,
    },
  ],
})
export class AuthConfigModule {}
